import type { UserProfile } from '~/prix'
import type { Variable } from './variables.typing'

export default function recommendedVariableForUser(
  _user: UserProfile,
  variables: Variable[],
): Variable | null {
  const highlighted = variables.filter(variable => variable.userHighlightedVariable)
  const source = highlighted.length > 0 ? highlighted : variables

  return (
    [...source].sort((left, right) => Number(right.relevance || 0) - Number(left.relevance || 0))[0] ||
    null
  )
}
